import { render, staticRenderFns } from "./Renewal.vue?vue&type=template&id=5697ea4f&scoped=true&"
import script from "./Renewal.vue?vue&type=script&lang=ts&"
export * from "./Renewal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5697ea4f",
  null
  
)

export default component.exports